import './registerServiceWorker';

import Vue from 'vue';

import Store from '@/services/Store';

import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

Store.initCurrentQuiz().then(() => {
	new Vue({
		router,
		created() {},
		methods: {},
		mounted: function() {},
		render: (h) => h(App),
	}).$mount('#appCanvas');
});
